import src from "IMAGE";
export default { src, width: 1024, height: 1024, blurWidth: 0, blurHeight: 0};
